import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataPrerequisite } from '@onefootprint/request-types/dashboard';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import BaseNode from '../base-node';
import { PrerequisiteForm } from './components/form';
const PrerequisiteSchemaNode = node => {
  const $ = _c(7);
  let t0;
  if ($[0] !== node.data || $[1] !== node.id) {
    t0 = {
      render: t1 => {
        const {
          mutation,
          canEdit
        } = t1;
        return <PrerequisiteForm nodeId={node.id} node={node.data} mutation={mutation} canEdit={canEdit} />;
      },
      form: "prerequisite-node",
      size: "lg"
    };
    $[0] = node.data;
    $[1] = node.id;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== node.data || $[4] !== node.id || $[5] !== t0) {
    t1 = <BaseNode nodeId={node.id} data={node.data} sidebar={t0} />;
    $[3] = node.data;
    $[4] = node.id;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
export default PrerequisiteSchemaNode;